import {
  required, minLength, maxLength, email,
} from 'vuelidate/lib/validators';

export default {
  headers: [
    { text: 'Meno', value: 'name' },
    { text: 'Priezvisko', value: 'name' },
    { text: 'ŠPZ', value: 'licence_plate' },
    { text: 'Typ kontroly', value: 'check_human' },
    { text: 'Prevádzka', value: 'branch_human' },
    { text: 'Technik', value: 'user_human' },
    { text: 'Email', value: 'email' },
    { text: 'Telefón', value: 'phone' },
    { text: 'Dátum kontroly', value: 'reservation_stamp' },
    { text: 'Akcie', value: 'action', sortable: false },
  ],
  formModel: [{
    name: 'name',
    type: 'text',
    label: 'Meno',
    class: 'sm6',
    icon: 'person',
    validations: {

      maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'surname',
    type: 'text',
    label: 'Priezvisko',
    // class: 'sm12',
    class: 'sm6',
    icon: 'person',
    validations: {

      maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },

  {
    name: 'email',
    type: 'text',
    label: 'Email',
    // class: 'sm12',
    class: 'sm12',
    icon: 'email',
    validations: {

      email,
      maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'phone',
    type: 'text',
    label: 'Telefón',
    // class: 'sm12',
    class: 'sm12',
    icon: 'phone',
    validations: {

      maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'licence_plate',
    type: 'text',
    label: 'ŠPZ',
    // class: 'sm12',
    class: 'sm6',
    icon: 'edit',
    validations: {
      required,
      maxLength: maxLength(7),
    },
    // defaultValue: 'test'
  },
  {
    name: 'car_type',
    type: 'select',
    label: 'Druh auta',
    // class: 'sm12',
    class: 'sm6',
    icon: 'sync',
    validations: {
      required,
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'enum-items?filters[enums]=2',
  },
  {
    name: 'check_type',
    type: 'select',
    label: 'Druh kontroly',
    // class: 'sm12',
    class: 'sm6',
    icon: 'sync',
    validations: {
      required,
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'enum-items?filters[enums]=15',
  },
  {
    name: 'fuel_type',
    type: 'select',
    label: 'Druh paliva',
    // class: 'sm12',
    class: 'sm6',
    icon: 'sync',
    validations: {
      required,
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'enum-items?filters[enums]=16',
  },
  {
    name: 'branches_id',
    type: 'select',
    label: 'Prevádzka',
    // class: 'sm12',
    class: 'sm6',
    icon: 'sync',
    validations: {
      required,
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'branches',
  },
  {
    name: 'state',
    type: 'select',
    label: 'Stav',
    // class: 'sm12',
    class: 'sm12',
    icon: 'sync',
    validations: {
      required,
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'enum-items?filters[enums]=1',
  },
  {
    name: 'reservation_date',
    type: 'date',
    label: 'Dátum kontroly',
    class: '',
    class: 'sm6',
    icon: 'time',
    validations: {
      // required, maxLength: maxLength(10)
    },
  },
  {
    name: 'reservation_time',
    type: 'time',
    label: 'Čas kontroly',
    class: '',
    class: 'sm6',
    icon: 'time',
    validations: {
      // required, maxLength: maxLength(10)
    },
  },
  {
    name: 'note',
    type: 'textarea',
    label: 'Poznámka',
    // class: 'sm12',
    class: 'sm12',
    icon: 'email',
    validations: {
      maxLength: maxLength(10000),
    },
    // defaultValue: 'test'
  },
  {
    name: 'users_id',
    type: 'autocomplete',
    label: 'Technik',
    // class: 'sm12',
    class: 'sm12',
    icon: 'person',
    validations: {
      // required, maxLength: maxLength(255)
    },
    text: 'name',
    value: 'id',
    defaultValue: 'users',
  },

  ],
};
